import React, { Component } from 'react';
//import Helmet from 'react-helmet';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import './content/content.css';

class SearchExamples extends Component {

	constructor() {
		super();
		this.handleWebTechExample = this.handleWebTechExample.bind(this);
		this.handleLibraryExample = this.handleLibraryExample.bind(this);
		this.handleSeoExample = this.handleSeoExample.bind(this);
		this.handleSecurityExample = this.handleSecurityExample.bind(this);
	}

	handleWebTechExample() {
		this.props.handleSubmitWithOptionsUpdate(0, 'cdn.mxpnl.com', 'Top 500k', 'JS');
	}

	handleLibraryExample() {
		this.props.handleSubmitWithOptionsUpdate(0, 'bootstrap.min.js', 'Top 500k', 'JS & HTML');
	}

	handleSeoExample() {
		this.props.handleSubmitWithOptionsUpdate(0, 'enterprise', 'Top 500k', 'Meta & Title');
	}

	handleSecurityExample() {
		this.props.handleSubmitWithOptionsUpdate(0, 'nginx 1.4.6', 'Top 500k', 'HTTP Headers');
	}	

  render() {

    return (
      <div>
      		<Grid>
      			<Row>
      				<Col md={3} className="search-example">
			  			<h4>Web Tech</h4>
			  			<h5>Websites using Mixpanel</h5>
		                <Button bsStyle="default" className="btn-inline" onClick={this.handleWebTechExample}>
		                    <i className="fa fa-search" aria-hidden="true"/>Mixpanel
		                </Button>
      				</Col>
      				<Col md={3} className="search-example">
			   			<h4>Libraries</h4> 
			   			<h5>Websites built with Bootstrap</h5>
		                <Button bsStyle="default" className="btn-inline" onClick={this.handleLibraryExample}>
		                    <i className="fa fa-search" aria-hidden="true"/>Bootstrap		                    
		                </Button>
		                 
      				</Col>
      				<Col md={3} className="search-example">
			   			<h4>SEO</h4>
			   			<h5>Websites targeting enterprise</h5>
		                <Button bsStyle="default" className="btn-inline" onClick={this.handleSeoExample}>
		                    <i className="fa fa-search" aria-hidden="true"/>Enterprise
		                </Button>
      				</Col>
      				<Col md={3} className="search-example">
			   			<h4>Security</h4>
			   			<h5>Websites hosted on Nginx</h5>
		                <Button bsStyle="default" className="btn-inline" onClick={this.handleSecurityExample}>
		                    <i className="fa fa-search" aria-hidden="true"/>Nginx
		                </Button>
      				</Col>
      			</Row>
      		</Grid>
      </div>
    );
  }
}

export default SearchExamples;



// WEBPACK FOOTER //
// ./src/SearchExamples.js